<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { getToastStore } from '@skeletonlabs/skeleton';
  import Button from '$lib/components/common/button/Button.svelte';
  import { entityStore, setUIState } from '$lib/stores/entityStore';

  export let clientId: number;

  const dispatch = createEventDispatcher();
  const toastrStore = getToastStore();

  let name = '';
  let loading = false;

  async function createEntity(): Promise<void> {
    loading = true;

    try {
      await entityStore.create(clientId, { name });
      dispatch('entityCreated');
    } catch (errors) {
      for (const error of errors) {
        toastrStore.trigger({
          message: `${error.key} - ${error.value}`,
          background: 'bg-error-500',
          classes: 'text-white',
        });
      }
    } finally {
      loading = false;
    }
  }
</script>

<div class="card my-6 bg-[#FAFAFC] p-6">
  <div class="mb-5 text-lg font-bold text-primary-500">Add Entity</div>

  <div class="border border-[#EEEEEE] bg-[#FFFFFF] p-5 rounded-container-token">
    <div class="flex flex-col">
      <label for="name" class="mb-2 text-sm text-gray-700">Name</label>
      <input type="text" id="name" bind:value={name} class="input" />
    </div>

    <div class="mt-4 flex justify-end space-x-4">
      <Button label="Cancel" size="medium" variant="outlined" onClick={() => setUIState('DataTable')} />
      <Button label="Add Entity" colour="primary" size="medium" onClick={createEntity} disabled={loading || !name.trim()} />
    </div>
  </div>
</div>